import React from 'react';
import { Helmet } from 'react-helmet';
import { Button, Table } from '@components';

export const ParcelaAdicionalHistorico = ({
  dadosParcelaAdicional,
  handleRegistraOpcao,
}) => {
  return (
    <>
      <Helmet>Forluz - Parcela adicional</Helmet>

      <div className="card">
        <div className="card-body">
          <div className="row col-12">
            <Table
              className="mt-2 mb-32"
              columns={[
                'Data do pedido',
                'Status',
                'Previsão de pagamento',
                'Ações',
              ]}
            >
              {dadosParcelaAdicional.historico.length > 0 ? (
                dadosParcelaAdicional.historico.map((item) => (
                  <tr key={item.DataRegSol}>
                    <td>{item.DataSol}</td>
                    <td>{item.StatusSol}</td>
                    <td>{item.Previsao}</td>
                    <td>
                      {item.StatusSol === 'A efetivar' &&
                        item.OpcaoSol === 'Sim' &&
                        dadosParcelaAdicional.CdConsistencia !== '10' && (
                          <Button
                            className="justify-content-center"
                            transparent
                            color="orange"
                            onClick={() => {
                              handleRegistraOpcao('N');
                            }}
                          >
                            Cancelar
                          </Button>
                        )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-gray-500 py-4">
                    <b>
                      Sem pedidos vigentes para o calendário de{' '}
                      {new Date().getFullYear()}
                    </b>
                  </td>
                </tr>
              )}
            </Table>
          </div>
        </div>
      </div>
    </>
  );
};
